// src\themes\default\components\ProductView.tsx
import Container from "@/components/shared/Container";
import { ShopTag } from "@/core/models/shop-tag-model";
import Link from "next/link";
import { MainShopProduct, ProductColor } from "@/core/models/shop-product-model";
import RelatedProducts from "../elements/Product/RelatedProducts";
import ProductInformation from "../elements/Product/ProductInformation";
import ProductGallery from "../elements/Product/ProductGallery";
import ProductComments from "../elements/comment/ProductComment";
import WidgetsRender from "@/components/main/widgets/WidgetsRender";

interface GalleryData {
    image_info: Array<{
        url: string;
        alt?: string;
    }>;
}

interface ProductViewProps {
    product: MainShopProduct;
    gallery: GalleryData;
    colors: ProductColor[];
    id: number;
}

//////////////////////////

export default function ProductView({ product, gallery, colors, id }: ProductViewProps) {
    return (
        <Container className="flex flex-col gap-12 mt-10 px-4">
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
                <div className="col-span-1 md:col-span-3 md:pe-35">
                    {/* {gallery.image_info.length > 0 || product.thumbnail && ( */}
                    <ProductGallery images={gallery.image_info} product={product} />
                    {/* )} */}
                </div>
                <aside className="col-span-1 md:col-span-2 sticky top-20 h-fit">
                    <ProductInformation product={product} colors={colors} />
                </aside>
            </div>
            <div className="flex flex-wrap gap-2 my-2.5">
                {product.tags.map((tag: ShopTag) => (
                    <Link
                        key={tag.id}
                        href={`/shop/category/products/all?tag=${tag.slug}`}
                        className="inline-block px-3 py-1.5 bg-primary-200 text-primary-900 text-sm rounded-xs hover:bg-primary-300 transition-colors no-underline"
                    >
                        #{tag.title}
                    </Link>
                ))}
            </div>
            {/* by now widgets render for all themes because WidgetsRender is now here in default ProductView
            if in future decides to active for each theme seprately it should remove from here and add to
            related theme */}
            {
                product.blog &&
                <div className="grid grid-cols-12 gap-x-4 gap-y-11 md:gap--x-13 md:gap-y-13 lg:gap-y-18 lg:gap-x-18 mx-auto w-full">
                    <WidgetsRender widgets={product.blog.content} />
                </div>
            }
            <RelatedProducts productId={id} />
            <ProductComments productId={id} />
        </Container>
    )
}
